export const scanFilterParams = (filterValues) => ({
  readerId: filterValues?.reader?.value,
  passId: filterValues?.pass || undefined,
  scanType: filterValues?.scanType?.value,
  status: filterValues?.status?.value,
  validationType: filterValues?.validationType?.value,
  groupTags: filterValues?.groupTags?.length
    ? filterValues.groupTags.map((tag) => tag.label)
    : undefined,
  passTemplateId: filterValues?.passTemplate?.length
    ? filterValues.passTemplate.map((template) => template.value)
    : undefined,
  createdAfter: filterValues?.createdAfter || undefined,
  createdBefore: filterValues?.createdBefore || undefined,
});
